import script from "./home-carousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./home-carousel.vue?vue&type=script&setup=true&lang=ts"

import "./home-carousel.vue?vue&type=style&index=0&id=f90d344e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f90d344e"]])

export default __exports__